import {UserRolesEnum} from './app/modules/models-management/types';

export const DEFAULT_ROLE = UserRolesEnum.USER;
export class AppLocator {
  public static forceUsingRealApi = true;
  public static showPermissionCodes = false;
  public static forceUseRole: UserRolesEnum;
}
